import { render, staticRenderFns } from "./tugas.vue?vue&type=template&id=4e172968"
import script from "./tugas.vue?vue&type=script&lang=js"
export * from "./tugas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports